import { Box } from '@mui/material';
import React from 'react';

// Utility to get difference in days between two dates
const getDayDifference = (start: string, end: string) => {
  const startDate = new Date(start);
  const endDate = new Date(end);
  const timeDiff = endDate.getTime() - startDate.getTime();
  return Math.floor(timeDiff / (1000 * 3600 * 24)) + 1;
};

// Props
interface BarProps {
  name: string;
  firstStartDate: string;
  start: string; // e.g., '2025-05-10'
  end: string; // e.g., '2025-05-15'
  color?: string;
  extraClass?: any;
}

const HorizontalBar: React.FC<BarProps> = ({
  name,
  firstStartDate,
  start,
  end,
  color = '#4ade80',
  extraClass,
}) => {
  const days = getDayDifference(start, end);
  const widthPerDay = 38; // Each day is 30px wide
  const barWidth = days * widthPerDay;
  var marginDifference = getDayDifference(firstStartDate, start) * 38;
  if (marginDifference === 38) {
    marginDifference = 0;
  }
  return (
    <div className={'mb-4 ' + extraClass}>
      <div className="relative h-6 bg-gray-100 rounded">
        <div
          className="h-6 rounded text-xs text-white flex items-center pl-2"
          style={{
            width: `${barWidth}px`,
            // marginLeft: `${marginDifference}px`,
            height: '20px',
            backgroundColor: color,
          }}
        >
          <Box sx={{ opacity: 0 }}> {name}</Box>
        </div>
      </div>
    </div>
  );
};

export default HorizontalBar;
